import { CreateMessageRequest } from '@src/main/modules/messages/infrastructure/dto/createMessageRequest';
import { createOutboxMessageHttpRepository } from '@src/main/modules/messages/infrastructure/repository/OutboxMessageHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const createMessageUseCase = async (
  data: CreateMessageRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createOutboxMessageHttpRepository(tokenProvider);
  return await repository.create(data);
};
